import React from 'react';
import styles from './ValueWithUnit.module.css'; // Import your CSS module

const ValueWithUnit = (props) => {
  const {
    schema,
    idSchema,
    formData = {},
    onChange,
    registry,
    disabled,
    readonly,
    autofocus,
    uiSchema = {},
    required,
    errorSchema = {},
    onBlur,
    onFocus,
    formContext,
  } = props;

  const { value, unit } = formData;

  const { widgets } = registry;
  const { UpDownWidget, SelectWidget } = widgets;

  // Extract placeholders from uiSchema
  const valueUiSchema = uiSchema.value || {};
  const unitUiSchema = uiSchema.unit || {};

  const valuePlaceholder = valueUiSchema['ui:placeholder'] || '';
  const unitPlaceholder = unitUiSchema['ui:placeholder'] || '';

  // Error handling
  const valueError =
    errorSchema.value &&
    errorSchema.value.__errors &&
    errorSchema.value.__errors[0];
  const unitError =
    errorSchema.unit &&
    errorSchema.unit.__errors &&
    errorSchema.unit.__errors[0];

  // Event handlers
  const handleValueChange = (newValue) => {
    console.log('newValue:', newValue? Number(newValue): null);
    onChange({ ...formData, value: newValue ? Number(newValue) : null });
  };

  const handleUnitChange = (newUnit) => {
    onChange({ ...formData, unit: newUnit });
  };

  return (
    <div className={styles.field}>
      <div className={styles.container}>
        {/* Value Field */}
        <div className={styles.valueField}>
          <UpDownWidget
            fullWidth
            options={{
              ...schema.properties.value.options,
              placeholder: valuePlaceholder,
            }}
            schema={schema.properties.value}
            id={idSchema.value && idSchema.value.$id}
            value={value}
            required={required}
            disabled={disabled}
            readonly={readonly}
            autofocus={autofocus}
            onChange={handleValueChange}
            onBlur={onBlur}
            onFocus={onFocus}
            label={schema.properties.value.title || 'Value'}
            uiSchema={uiSchema.value || {}}
            errorSchema={errorSchema.value || {}}
            registry={registry}
            formContext={formContext}
          />
          {valueError && (
            <div className={styles.errorMessage}>{valueError}</div>
          )}
        </div>

        {/* Unit Field */}
        <div className={styles.unitField}>
          <SelectWidget
            fullWidth
            options={{
              enumOptions: schema.properties.unit.enum.map((u) => ({label: u,value: u,})),
              placeholder: unitPlaceholder,
            }}
            schema={schema.properties.unit}
            id={idSchema.unit && idSchema.unit.$id}
            value={unit}
            required={required}
            disabled={disabled}
            readonly={readonly}
            autofocus={autofocus}
            onChange={handleUnitChange}
            onBlur={onBlur}
            onFocus={onFocus}
            label={schema.properties.unit.title || 'Unit'}
            uiSchema={uiSchema.unit || {}}
            errorSchema={errorSchema.unit || {}}
            registry={registry}
            formContext={formContext}
          />
          {unitError && (
            <div className={styles.errorMessage}>{unitError}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export { ValueWithUnit };
